import React, { Component } from "react";
import { connect } from "react-redux";
import config from "config/api";
import Spinner from "components/UI/Spinner";
import i18n from "helpers/i18n";
import Immutable from "immutable";
// import Prettyfier from 'components/UI/Prettyfier';
// import HomeMember from './HomeMember';
// import HomeSpeaker from './HomeSpeaker';
import HomeVisitor from "./HomeVisitor";
import HomeSubscribe from "./HomeSubscribe";
import Header from "../Header/Header";
import HeaderContent from "../Header/HeaderContent";
import HeaderSub from "../Header/HeaderSub";
import Footer from "../Footer";
import HomeHelp from "components/Home/HomeHelp";
import ScrollToTopOnMount from "components/UI/ScrollToTopOnMount";
// import { Redirect } from 'react-router-dom'
import getLiveEvent from "helpers/getLiveEvent";
import getMySubscriptions from "helpers/getMySubscriptions";
import EventCardBanner from 'components/Event/EventCardBanner';
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import {
  fetchData,
  getDataHome,
  getLoadingError,
} from "../../ducks/asyncFetcher";
import {
  isLoggedIn,
  getCurrentUserRole,
  getCurrentUser,
  isStateKnown,
} from "ducks/authentication";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { primaryColor } from "../../helpers/colors";

const styles = (theme) => {
  return {
    root: {
      minHeight: "100%",
      // height: '100%',
      maxWidth: "1280px",
      margin: "0 auto",
    },
    wrapper: {
      // maxWidth: '1280px',
      // margin: '0 auto',
      // height: '100%',
      height: "calc(100% - 118px)",
      // background: 'linear-gradient(180deg, rgba(241,243,244,0.42) 0%, rgba(223,227,229,0.42) 100%)',
      borderBottom: "3px " + primaryColor + " solid",
    },
    titleSmall: {
      fontSize: "2rem",
      [theme.breakpoints.down("xs")]: {
        fontSize: "1.2rem",
        textAlign: "center",
      },
    },
    headerImage: {
      textAlign: "right",
      [theme.breakpoints.down("sm")]: {
        marginTop: theme.spacing(2),
        textAlign: "center",
      },
    },
  };
};

const AF_KEY = "home";
const LIVE_ACTIVATION_DELAY = process.env.REACT_APP_SITE === "pneumo" ? 30 : 15;
class Home extends Component {
  componentDidMount() {
    this.props.onMount();
    // console.log('mount home')
  }

  componentDidUpdate(oldProps) {
    // if (oldProps.authStateKnown === undefined && this.props.authStateKnown !== undefined)
    //   this.props.onMount();
  }

  _getMyPastEvent() {
    const { $$data } = this.props;
    if ($$data !== undefined) {
      // console.log($$data.toJS())
      // console.log($$subscriptions)
      // console.log($$data.get('myfutureevents'))
      // console.log($$data.get('mypastevents').filter($e => $e.get('hasAttended') !== undefined && $e.get('hasAttended') !== '' && $e.get('hasAttended') !== null).toJS())
    }
    return $$data !== undefined &&
      $$data.get("mypastevents") !== undefined &&
      $$data.get("mypastevents").size > 0
      ? $$data
          .get("mypastevents")
          .filter(
            ($e) =>
              $e.get("hasAttended") !== undefined &&
              $e.get("hasAttended") !== "" &&
              $e.get("hasAttended") !== null
          )
          .get(0)
      : undefined;
  }
  _getMyLiveEvent() {
    const { $$data, userRole } = this.props;
    const $$subscriptions = getMySubscriptions({ userRole, $$data });
    return getLiveEvent({ $$data, $$subscriptions });
  }
_onLiveStarted() {

}
  render() {
    const {
      $$data,
      userRole,
      onPanelToggle,
      $$user,
      classes,
      subscribe,
      themeId,
    } = this.props;
    // console.log(isStateKnown)
    // console.log('home', {userRole})
    let finalThemeId = themeId;
    let redirectToEvent = false;
    if (process.env.REACT_APP_SITE === "pneumo_medevent") {
      // finalThemeId = process.env.REACT_APP_MEDEVENT_THEME;
      // redirectToEvent = true;
    }

    const $$subscriptions =
      userRole !== undefined &&
      $$data !== undefined &&
      $$data.get("myfutureevents") !== undefined
        ? $$data.get("myfutureevents").map((e) => e.get("id"))
        : Immutable.Map();

    const $$pastEvents = this._getMyPastEvent();

    const $$liveEvent = $$data !== undefined ? this._getMyLiveEvent() : undefined;
    // const $$liveEvent = undefined;



    // if ($$liveEvent !== undefined)
// console.log('liiive', $$liveEvent.toJS())

    let $$availableEvents;
    if ($$data !== undefined && (subscribe === true || redirectToEvent === true)) {
      if (finalThemeId === undefined)
        $$availableEvents = $$data.get("availableEvents");
      else
        $$availableEvents = $$data
          .get("availableEvents")
          .filter(($$event) => $$event.get("themeId") === finalThemeId);
    }

    return (
      <div className={classes.root}>
        <div className={classes.wrapper}>
          <Header
            onPanelToggle={onPanelToggle}
            current="home"
            headerTitle={undefined}
            headerContent={
              process.env.REACT_APP_SITE !== "pneumo" && process.env.REACT_APP_SITE !== "pneumo_medevent" ? (
                <HeaderContent />
              ) : undefined
            }
          />
        {process.env.REACT_APP_SITE === "pneumo" || process.env.REACT_APP_SITE === "pneumo_medevent" ? (
            <HeaderSub inHeader size={subscribe === true ? "small" : "big"} />
          ) : undefined}
          <ScrollToTopOnMount />
          <Choose>
            <When condition={$$data !== undefined && subscribe !== true && redirectToEvent !== true}>
              <HomeVisitor
                $$data={$$data}
                $$user={$$user}
                userRole={userRole}
                isLoggedIn={isLoggedIn}
                onSubscriptionComplete={this.props.onMount}
              />
            </When>
            <When condition={$$data !== undefined && subscribe === true && redirectToEvent !== true}>
              <HomeSubscribe
                $$availableEvents={$$availableEvents}
                $$user={$$user}
                userRole={userRole}
                isLoggedIn={isLoggedIn}
                onSubscriptionComplete={this.props.onMount}
                $$subscriptions={$$subscriptions}
                $$pastEvents={$$pastEvents}
                themeId={finalThemeId}
              />
            </When>
            <When condition={$$data !== undefined && redirectToEvent === true}>
              <If condition={$$liveEvent !== undefined && (userRole === 'member' || userRole === 'staff' || userRole === 'admin')}>
              <EventCardBanner $$card={$$liveEvent} userRole={userRole} $$subscriptions={$$subscriptions}  $$user={$$user} showRemainingTime={true} onLiveStarted={this._onLiveStarted} delay={LIVE_ACTIVATION_DELAY}/>

              <Box width="100%" pt={4}>
                <HomeHelp />
              </Box>
              </If>

              <If condition={$$liveEvent === undefined }>
              <HomeSubscribe
                $$availableEvents={$$availableEvents}
                $$user={$$user}
                userRole={userRole}
                isLoggedIn={isLoggedIn}
                onSubscriptionComplete={this.props.onMount}
                $$subscriptions={$$subscriptions}
                $$pastEvents={$$pastEvents}
                themeId={finalThemeId}
                directRegistration={true}
              />
          </If>
            </When>
            <Otherwise>
              <div className={"Loading"}>
                <Spinner style={{ marginTop: 200 }}>Chargement...</Spinner>
              </div>
            </Otherwise>
          </Choose>
        </div>
        <Footer />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    $$data: getDataHome(state),
    error: getLoadingError(state),
    isLoggedIn: isLoggedIn(state),
    userRole: getCurrentUserRole(state),
    authStateKnown: isStateKnown(state),
    $$user: getCurrentUser(state),
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  return {
    onMount: () => {
      dispatch(fetchData({ key: AF_KEY, fetchUrl: config.home }));
    },
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Home))
);



// WEBPACK FOOTER //
// ./src/components/Home/Home.jsx